




















import { defineComponent, computed, ref } from "@vue/composition-api";
import RightDrawer from "@/components/Pages/Scout/elements/RightDrawer/index.vue";
import MessageTemplatePanel from "@/components/Pages/Scout/MessageTemplates/MessageTemplateRightDrawer/MessageTemplatePanel/index.vue";
import { MessageTemplate } from "@/components/Pages/Scout/MessageTemplates/MessageTemplateRightDrawer/MessageTemplatePanel/types";
import { TemplateRow } from "@/components/Pages/Scout/MessageTemplates/MessageTemplateList/MessageTemplateRow/types";

export default defineComponent({
  name: "MessageTemplateRightDrawer",
  components: { RightDrawer, MessageTemplatePanel },
  emit: ["cancel", "send"],
  props: {
    isShow: {
      type: Boolean,
      required: true
    },
    headerText: {
      type: String,
      default: ""
    },
    template: {
      type: Object as () => TemplateRow | null,
      default: null
    }
  },
  setup(props, { emit }) {
    const selectedTemplate = computed(() => props.template);

    const minWidth = ref<string>("800px");

    const handleClickedCancel = () => {
      emit("cancel");
    };

    const handleClickedSend = (template: MessageTemplate) => {
      emit("send", template);
    };

    const handleClickedOutside = () => {
      emit("outside");
    };

    const handleMouseOver = () => {
      emit("mouseover");
    };

    const handleMouseLeave = () => {
      emit("mouseleave");
    };

    return {
      selectedTemplate,
      minWidth,
      handleClickedCancel,
      handleClickedSend,
      handleClickedOutside,
      handleMouseOver,
      handleMouseLeave
    };
  }
});
